import { FC } from 'react';
import { Grid } from '@mui/material';
import BloodGlucose from '../Reading/BloodGlucose';
import BloodPressure from '../Reading/BloodPressure';
import PulseOximeter from '../Reading/PulseOximeter';
import WeightScale from '../Reading/WeightScale';
import { IBloodPressureReading, ILatestReadings } from '~/services/api/readings/types';
import { Timezone } from '~/types';
import { INotificationRule } from '~/services/api/notificationRules/types';

import styles from './LatestReadings.module.scss';

interface IProps {
  latestReadings: ILatestReadings;
  notificationRules: INotificationRule[];
  timezone: Timezone;
  onBloodPressureUpdated: (data: IBloodPressureReading) => void;
}

const LatestReadings: FC<IProps> = ({
  latestReadings,
  notificationRules,
  timezone,
  onBloodPressureUpdated,
}) => (
  <>
    <Grid container spacing={1} className={styles.container}>
      {latestReadings.bloodPressure && (
        <Grid item xs={4}>
          <BloodPressure
            reading={latestReadings.bloodPressure}
            rules={notificationRules}
            timezone={timezone}
            onUpdated={onBloodPressureUpdated}
            isEdit
          />
        </Grid>
      )}

      {latestReadings.weightScale && (
        <Grid item xs={4}>
          <WeightScale
            reading={latestReadings.weightScale}
            rules={notificationRules}
            timezone={timezone}
          />
        </Grid>
      )}

      {latestReadings.pulseOximeter && (
        <Grid item xs={4}>
          <PulseOximeter
            reading={latestReadings.pulseOximeter}
            rules={notificationRules}
            timezone={timezone}
          />
        </Grid>
      )}
      {latestReadings.bloodGlucose && (
        <Grid item xs={4}>
          <BloodGlucose
            reading={latestReadings.bloodGlucose}
            rules={notificationRules}
            timezone={timezone}
          />
        </Grid>
      )}
    </Grid>
  </>
);

export default LatestReadings;
